const defaultState = {};

export default (state = {}, action) => {
  let log = { ...state };
  switch (action.type) {
    case 'LOGOUT':
      return defaultState;
    case 'LOG_SET':
      log[action.method] = action.log;
      return log;
    default:
      return state;
  }
};
